import { fetchData, postFileData, fetchFileData, fetchDeleteData } from '../utils/fetchData';
import { API_BASE_URL, RESOURCES } from '../utils/constants/constants';

export function getUserSelfInfo() {
  const resource = `${API_BASE_URL}${RESOURCES.userSelfInfo.info}`;
  return fetchData(resource);
}

export function putUserSelfInfo(userInfo) {
  const resource = `${API_BASE_URL}${RESOURCES.userSelfInfo.info}`;

  const payload = {
    method: 'PUT',
    body: JSON.stringify(userInfo),
    headers: {
      'Content-type': 'application/json',
    },
  };
  return fetchData(resource, payload);
}

export const uploadUserPicture = (file) => {
  const resource = `${API_BASE_URL}${RESOURCES.userSelfInfo.userPicture}`;
  return postFileData(resource, file);
};

export const getProfilePicture = () => {
  const resource = `${API_BASE_URL}${RESOURCES.userSelfInfo.userPicture}`;
  return fetchFileData(resource);
};

export async function deleteProfilePicture() {
  const resource = `${API_BASE_URL}${RESOURCES.userSelfInfo.userPicture}`;
  return fetchDeleteData(resource);
}

export function putUserPreferences(userPreferences) {
  const resource = `${API_BASE_URL}${RESOURCES.userSelfInfo.preferences}`;

  const payload = {
    method: 'PUT',
    body: JSON.stringify(userPreferences),
    headers: {
      'Content-type': 'application/json',
    },
  };
  return fetchData(resource, payload);
}

